/**
 * @generated SignedSource<<51f8949b6077346268e4312b729356f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AppSettingsFormUpdateMutation$variables = {
  description?: string | null;
  id: string;
  name?: string | null;
  slug?: string | null;
};
export type AppSettingsFormUpdateMutation$data = {
  readonly updateApp: {
    readonly description: string;
    readonly id: string;
    readonly name: string;
    readonly slug: string;
  };
};
export type AppSettingsFormUpdateMutation = {
  response: AppSettingsFormUpdateMutation$data;
  variables: AppSettingsFormUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "description",
        "variableName": "description"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "App",
    "kind": "LinkedField",
    "name": "updateApp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppSettingsFormUpdateMutation",
    "selections": (v4/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "AppSettingsFormUpdateMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "8a0788c675d6cb61c7c1b9791baa53ef",
    "id": null,
    "metadata": {},
    "name": "AppSettingsFormUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation AppSettingsFormUpdateMutation(\n  $id: ID!\n  $name: String\n  $description: String\n  $slug: String\n) {\n  updateApp(id: $id, name: $name, description: $description, slug: $slug) {\n    id\n    name\n    description\n    slug\n  }\n}\n"
  }
};
})();

(node as any).hash = "71c9c9b7a1e9f3ed7644ece531376267";

export default node;
